import * as THREE from 'three';
import { createTextMesh } from '../MeshHelpers';
import { createPartialCircleGeometry } from './GeometryHelpers';
import { roundNumber } from './NumberHelpers';

export function createAngleMeshTextObject(
  angleStart,
  angleLength,
  angleMaterial,
  fontSize
) {
  const innerRadius = 0.08;
  const outerRadius = 0.09;
  const textMargin = 0.01;
  const cirlceSegments = 16;
  const angleSymbol = '\u00B0';
  const angleString = roundNumber(THREE.Math.radToDeg(angleLength), 1)
    .toString()
    .replace('.', ',');
  const angleObject = new THREE.Object3D();

  const angleGeometry = createPartialCircleGeometry(
    innerRadius,
    outerRadius,
    cirlceSegments,
    angleStart,
    angleLength
  );
  const angleMesh = new THREE.Mesh(angleGeometry, angleMaterial);
  angleObject.add(angleMesh);

  const angleTextMeshData = createTextMesh(
    `${angleString}${angleSymbol}`,
    fontSize,
    -0.1
  );
  angleTextMeshData.mesh.position.add(
    new THREE.Vector3(1, 0, 0)
      .applyAxisAngle(new THREE.Vector3(0, 0, 1), angleStart + angleLength / 2)
      .multiplyScalar(
        outerRadius +
          textMargin +
          Math.hypot(angleTextMeshData.width / 2, angleTextMeshData.height / 2)
      )
  );
  angleObject.add(angleTextMeshData.mesh);

  return angleObject;
}

export function clampAngle(angle) {
  angle = angle % (Math.PI * 2);
  if (angle < Math.PI) {
    angle += Math.PI * 2;
  }
  if (angle > Math.PI) {
    angle -= Math.PI * 2;
  }
  return angle;
}
